import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography as MTypography } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  root: {
    fontFamily: 'Pretendard-Regular',
  },
});

export default function Typography(props) {
  const { ...rest } = props;
  const classes = useStyles();
  return <MTypography className={classes.root} {...rest} />;
}

Typography.propTypes = {
  variant: PropTypes.string,
};

Typography.defaultProps = {
  variant: 'body1',
};
